import React from 'react';
import './AboutPage.css';
import Header from '../header/Header';
import Footer from '../footer/Footer';

const AboutPage = () => {
  return (
    <div>
    <Header></Header>
    <div className="about-page">
      <div className="about-header">
        <h1>About Us</h1>
        <p>Providing reliable and fast broadband services across Delhi.</p>
      </div>
      <div className="content">
        <section className="intro">
          <h2>Welcome to Royal Broadband</h2>
          <p>
            At Royal Broadband, we are dedicated to bringing you the best internet experience
            with our high-speed broadband services. Our mission is to ensure seamless and
            uninterrupted internet connectivity to all our customers in Delhi.
          </p>
        </section>
        
        <section className="features">
          <h2>Why Choose Us?</h2>
          <ul>
            <li>
              <strong>High-Speed Internet:</strong> Experience blazing fast internet speeds
              with our advanced fiber optic technology.
            </li>
            <li>
              <strong>Reliable Connection:</strong> Our state-of-the-art infrastructure ensures
              minimal downtime and consistent performance.
            </li>
            <li>
              <strong>Affordable Plans:</strong> We offer a variety of plans to suit different
              needs and budgets, ensuring everyone can enjoy high-speed internet.
            </li>
            <li>
              <strong>Exceptional Customer Support:</strong> Our dedicated support team is
              available 24/7 to assist you with any queries or issues.
            </li>
            <li>
              <strong>Easy Installation:</strong> Our expert technicians provide hassle-free
              and quick installation services at your convenience.
            </li>
          </ul>
        </section>
        
        <section className="coverage">
          <h2>Coverage Area</h2>
          <p>
            We cover a wide range of areas in Delhi, ensuring that you have access to high-speed
            internet no matter where you are. From residential homes to commercial spaces, our
            network is designed to cater to all your internet needs.
          </p>
        </section>
        
        <section className="technology">
          <h2>Advanced Technology</h2>
          <p>
            Our broadband services are powered by the latest fiber optic technology, which
            provides superior speed and reliability compared to traditional broadband connections.
            Enjoy seamless streaming, gaming, and browsing with our cutting-edge solutions.
          </p>
        </section>
        
        <section className="testimonial">
          <h2>What Our Customers Say</h2>
          <p>
            "Royal Broadband has transformed our internet experience. The speed and reliability
            are unmatched, and their customer service is always prompt and helpful." - Rajesh Sharma
          </p>
        </section>
        
        <section className="commitment">
          <h2>Our Commitment</h2>
          <p>
            We are committed to providing the best broadband services in Delhi. Our continuous
            efforts to improve and innovate ensure that our customers always receive the best
            internet experience. Join us and experience the difference with Royal Broadband.
          </p>
        </section>
      </div>
    </div>
    <Footer></Footer>
    </div>
  );
};

export default AboutPage;
